import "core-js/modules/es6.function.name";

/* eslint-disable func-names */
var Plugins = function Plugins() {};

var p = Plugins.prototype;

p.push = function (plugin) {
  this[plugin.prototype.name] = plugin;
};

export default new Plugins();